import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ClipboardList, User } from "lucide-react";
import { useLang } from "../lib/i18n";

export const ClientBottomNav = () => {
  const nav = useNavigate();
  const loc = useLocation();
  const { t } = useLang();
  const items = [
    { to: "/area-clienti", icon: Home, label: t("home"), id: "home" },
    { to: "/area-clienti/ordini", icon: ClipboardList, label: t("my_orders"), id: "orders" },
    { to: "/area-clienti/richiedi", icon: User, label: t("nav_request"), id: "request" },
  ];
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 mx-auto flex max-w-md items-center justify-around border-t border-slate-200 bg-white/95 px-4 py-2 backdrop-blur-lg">
      {items.map((it) => {
        const active = loc.pathname === it.to;
        const Icon = it.icon;
        return (
          <button key={it.id} data-testid={`bottomnav-${it.id}`} onClick={() => nav(it.to)}
            className={`flex flex-col items-center gap-0.5 rounded-lg px-3 py-1 text-[11px] font-semibold transition ${active ? "text-blue-600" : "text-slate-400"}`}>
            <Icon className="h-5 w-5" />
            <span className="max-w-[92px] truncate">{it.label}</span>
          </button>
        );
      })}
    </nav>
  );
};
